import { loadJs } from 'bits/load'

const GOOGLE_API_KEY = 'AIzaSyDVS4t6WZpqHnbglX3YM6W3SsWldcgKx-A' // staging api key for map

function loadGoogleMapsApi(googleApiKey?, options = { timeout: 10000 }): Promise<any> {
  const CALLBACK_NAME = '__googleMapsApiOnLoadCallback'
  // Reject the promise after a timeout
  return new Promise((resolve, reject): void => {
    const timeoutId = setTimeout((): void => {
      window[CALLBACK_NAME] = (): void => {} // Set the on load callback to a no-op
      reject(new Error('Could not load the Google Maps API'))
    }, options.timeout)
    // Hook up the on load callback
    window[CALLBACK_NAME] = (): void => {
      if (timeoutId !== null) {
        clearTimeout(timeoutId)
      }
      resolve(google.maps)
      delete window[CALLBACK_NAME]
    }
    loadJs(
      `https://maps.googleapis.com/maps/api/js?key=${googleApiKey ||
        GOOGLE_API_KEY}&callback=${CALLBACK_NAME}&libraries=geometry,places`,
    )
  })
}

export default loadGoogleMapsApi
